import React, { Component } from "react";
import { withStyles } from "@material-ui/core";
import { CalendarStyles } from "../../../styles/styles";
import { withTranslation } from 'react-i18next';
import { ValidationType, ValidationTypeName } from '../../../Enums';

class ValidationErrorPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            validationErrors: props.validationErrorsResponse,
            statusValidationErrors: props.statusValidationErrorsResponse,
        };
    }

    getErrorText = (validationError) => {
        const { t } = this.props;
        let errorMsg = "";

        switch (validationError.validationType) {
            case ValidationType.ScheduleRules:
                if (validationError.validationSubType) {
                    switch (validationError.validationSubType[0]) {
                        case 1:
                            errorMsg = t(`validationError.${ValidationTypeName[validationError.validationType]}.ValidateMaxHoursPerDay`);
                            break;
                        case 2:
                            errorMsg = t(`validationError.${ValidationTypeName[validationError.validationType]}.ValidateMaxShiftsPerDay`);
                            break;
                        default:
                            break;
                    }
                }
                break;
            case ValidationType.AllowedTimeBeforeShift:
            case ValidationType.ShiftMayOverlap:
            case ValidationType.EmployeNotOnProbation:
            case ValidationType.SkillsAndCertifs:
            case ValidationType.JobTransferSetValidation:
            case ValidationType.DateAndDuration:
            case ValidationType.RestBetweenShifts:
            case ValidationType.EmployeeEligibility:
            case ValidationType.MultipleShiftOnSameDay:
            case ValidationType.MaxHoursInRollingPeriod:
            case ValidationType.PaycodeOverlap:
            case ValidationType.EmployeeRestriction:
                errorMsg = t(`validationError.${ValidationTypeName[validationError.validationType]}`);
                break;
            default:
                break;
        }

        return errorMsg;
    }

    getStatusErrorText = (statusValidationError) => {
        const { t } = this.props;

        switch (statusValidationError.statusValidationType) {
            case 1://Auto-retracted
                return t("validationError.InvalidStatus.AutoRetracted");
            case 2: //already submitted by another EE
                return t("validationError.InvalidStatus.AlreadyTaken");
            default: return '';
        }
    }

    renderErrorList = () => {
        const { classes } = this.props;
        const { validationErrors } = this.state;

        return validationErrors.map((item, index) => {
            return (
                <div style={{ cursor: 'default' }} key={'validationErrors' + index} className={classes.historyItemContainer}>
                    <div className={classes.historyLogFirst}>
                        <span> {this.getErrorText(item)} </span>
                    </div>
                </div>
            )
        })
    }

    renderStatusErrorList = () => {
        const { classes } = this.props;
        const { statusValidationErrors } = this.state;

        return statusValidationErrors.map((item, index) => {
            return (
                <div style={{ cursor: 'default' }} key={'validationErrors' + index} className={classes.historyItemContainer}>
                    <div className={classes.historyLogFirst}>
                        <span> {this.getStatusErrorText(item)} </span>
                    </div>
                </div>
            )
        })
    }

    render() {
        return (
            <>
                <div style={{ marginTop: '15px' }}></div>
                {this.renderErrorList()}
                {this.renderStatusErrorList()}
            </>
        );
    }
}
export default withStyles(CalendarStyles)(withTranslation('employmentBillboard')(ValidationErrorPanel));
